import axios, { AxiosInstance } from "axios";

const instance: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SCHEDULER_API,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const getInstance = (): AxiosInstance => instance;
